export const amplitudeId = 366739658

export const mathOfferSlug = 'online-math-teacher'
export const elaOfferSlug = 'online-ela-teacher'
export const demoOfferSlug = 'online-demo-lesson-teacher'

export const mathQuestions = {
  nationality: '3481219',
  referrer_full_name: '3481222',
  referral_source: '3481223',
  job_posting_site: '3481224',
  teaching_experience_years: '3481227',
  onboarding_timeframe: '3481229',
  recommended: '3481221',
}

export const mathQuestionsListFlag = {
  age_confirmation: '3481220',
  has_bachelor_degree: '3481225',
  work_required_schedule: '3481228',
  accept_email_delivery: '3481230',
  accept_confidentiality: '3481231',
  accept_not_restricted_resident: '3481232',
  accept_data_processing_terms: '3481233',
}

export const elaQuestions = {
  nationality: '3492415',
  referrer_full_name: '3492418',
  referral_source: '3492419',
  job_posting_site: '3492420',
  teaching_experience_years: '4122301',
  onboarding_timeframe: '3492425',
  recommended: '3492417',
}

export const elaQuestionsListFlag = {
  age_confirmation: '3492416',
  has_bachelor_degree: '3492421',
  work_required_schedule: '3492424',
  accept_email_delivery: '3492426',
  accept_confidentiality: '3492427',
  accept_not_restricted_resident: '3492428',
  accept_data_processing_terms: '3492429',
}

export const demoQuestions = {
  nationality: '4121872',
  referrer_full_name: '4121875',
  referral_source: '4121876',
  job_posting_site: '4121877',
  teaching_experience_years: '4121879',
  onboarding_timeframe: '4121881',
  recommended: '4121874',
}

export const demoQuestionsListFlag = {
  age_confirmation: '4121873',
  has_bachelor_degree: '4121878',
  work_required_schedule: '4121880',
  accept_email_delivery: '4121882',
  accept_confidentiality: '4121883',
  accept_not_restricted_resident: '4121884',
  accept_data_processing_terms: '4121885',
}
